export enum RolesEnum {
  Admin = 'admin',
  Organiser = 'organiser',
  Analyst = 'analyst'
}
